// extracted by mini-css-extract-plugin
export default {"container":"lhwaHx","title":"Uhc1_R","description":"RTH_dU","reverseRow":"IK5xrm","row":"Jqf0NC","benefitText":"bzWSdG","benefitImage":"XZg8VH","benefitTextLeft":"vBqLdW"};